import { LocaleDict } from "@/i18n";
import { ComputeFieldComponent } from "../../computeFields";

export const SignatureCF: ComputeFieldComponent<{
  location: LocaleDict<string> | null;
  transcription: string;
}> = ({ input, lineBreak = false, language }) => {
  const signatureBase = input.location?.[language] ?? "";
  const transcription = input.transcription ? ` "${input.transcription}"` : "";

  const signature = `${signatureBase}${transcription}`;

  return (
    <>
      {signature}
      {signature && lineBreak && <br />}
    </>
  );
};
